// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  chat: getIcon('ic_chat'),
  user: getIcon('ic_user'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  track: getIcon('track'),
  schedule: getIcon('schedule'),
  invoicing: getIcon('invoicing'),
  settings: getIcon('settings'),
  trackDeliveries: getIcon('track-deliveries'),
};

const RetailerNavConfig = [
  {
    subheader: 'Home',
    items: [
      {
        title: 'Dashboard',
        path: PATH_DASHBOARD.retailer.hq.dashboard('deliveriesSummaryReport'),
        icon: ICONS.dashboard,
        childrenAreAnchorLinks: true,
        children: [
          { title: 'Order Analytics', path: PATH_DASHBOARD.retailer.hq.dashboard('deliveriesSummaryReport') },
          { title: 'Deliveries Summary', path: PATH_DASHBOARD.retailer.hq.dashboard('deliveriesSummary') },
        ],
      },
      {
        title: 'My Suppliers',
        path: PATH_DASHBOARD.retailer.hq.mySuppliers,
        icon: ICONS.trackDeliveries,
      },
    ],
  },
  {
    subheader: 'Account Management',
    items: [
      // {
      //   title: 'User',
      //   path: PATH_DASHBOARD.retailer.hq.users.list,
      //   icon: ICONS.user,
      //   children: [
      //     { title: 'Create', path: PATH_DASHBOARD.retailer.hq.users.new },
      //     { title: 'List', path: PATH_DASHBOARD.retailer.hq.users.list },
      //   ],
      // },
      {
        title: 'Account',
        path: PATH_DASHBOARD.retailer.hq.users.account,
        icon: ICONS.settings,
      },
    ],
  },
];

export default RetailerNavConfig;
